module.exports = {
    PASSWORD_CONFIRM_PASSWORD_SAME_VALIDATION: "Password and confirm password must be same.",
    ACTIVE_DEACTIVE_MESSAGE: "Are you sure you want to {active_deactive_status} this user?",
    USER_BULK_ACTION: "Are you sure you want to perform this action?",
}